import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { isLoggedIn } from "./pages/Auth/Helper";
import Login from "./pages/Auth/Login";
import Holder from "./pages/Holder";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import PendingApproval from "./pages/PendingApproval/PendingApproval";
import PendingClient from "./pages/PendingApproval/Client/PendingClient";
import PendingClientList from "./pages/PendingApproval/Client/PendingClientList";
import PendingVendor from "./pages/PendingApproval/Vendor/PendingVendor";
import PendingVendorList from "./pages/PendingApproval/Vendor/PendingVendorList";
import PendingJob from "./pages/PendingApproval/Job/PendingJob";
import PendingJobList from "./pages/PendingApproval/Job/PendingJobList";
import PendingProject from "./pages/PendingApproval/Project/PendingProject";
import PendingProjectList from "./pages/PendingApproval/Project/PendingProjectList";
import ClientUser from "./pages/UserManager/Client/ClientUser";
import ClientUserList from "./pages/UserManager/Client/ClientUserList";
import ConsultantUserList from "./pages/UserManager/Consultant/ConsultantUserList";
import ConsultantUser from "./pages/UserManager/Consultant/ConsultantUser";
import FlexpertUserList from "./pages/UserManager/Flexpert/FlexpertUserList";
import FlexpertRequestsList from "./pages/UserManager/Flexpert/FlexpertRequestsList";
import FlexpertsLayout from "./pages/Flexperts/FlexpertsLayout";
import VendorUserList from "./pages/UserManager/Vendor/VendorUserList";
import DeletedUsersList from "./pages/UserManager/DeletedUsers/DeletedUsersList"
import UserManager from "./pages/UserManager/UserManager";
import VendorUser from "./pages/UserManager/Vendor/VendorUser";
import JobManager from "./pages/JobManager/JobManager";
// Manage Broadcast Jobs / Manage Posted Jobs removed from CMS
// import JobMJob from "./pages/JobManager/Job/JobMJob";
// import JobMJobList from "./pages/JobManager/Job/JobMJobList";
// import JobMJobSub from "./pages/JobManager/JobSub/JobMJobSub";
// import JobMSubList from "./pages/JobManager/JobSub/JobMSubList";
import Dashboard from "./pages/Dashboard/Dashboard";
import EmailTemp from "./pages/EmailTemp/EmailTemp";
import EmailTemplates from "./pages/EmailTemp/Templates/EmailTemplates";
import EmailTempList from "./pages/EmailTemp/Templates/EmailTemplateList";
import EmailTempUpdate from "./pages/EmailTemp/Templates/EmailTemplateUpdate";
import EmailTemplateDesign from "./pages/EmailTemp/Templates/EmailTemplateDesign";
import EmailTemplateDesignList from "./pages/EmailTemp/Templates/EmailTemplateDesignList";
import FAQ from "./pages/FAQ/FAQ";
import FAQList from "./pages/FAQ/FAQList";
import FAQUpdate from "./pages/FAQ/FAQUpdate";
import FAQSort from "./pages/FAQ/FAQSort";
import BusinessType from "./pages/BuisnessType/BusinessType";
import BusinessTypeList from "./pages/BuisnessType/BusinessTypeList";
import BusinessTypeUpdate from "./pages/BuisnessType/BusinessTypeUpdate";
import JobCategory from "./pages/JobCategory/JobCategory";
import JobCategoryTypeList from "./pages/JobCategory/JobCategoryTypeList";
import JobCategoryUpdate from "./pages/JobCategory/JobCategoryUpdate";
import GenerateInvestorUrlWrapper from "./pages/GenerateInvestorUrl/GenerateInvestorUrlWrapper";
import GenerateInvestorUrl from "./pages/GenerateInvestorUrl/GenerateInvestorUrl";
import { ClientVendorConnection, UserInfoDashboard, VendorClientResourcesConnectionList } from "./pages";
import { MockInterviewList } from "./pages/AiMockInterview/MockInterviewList";
import AiResumeList from "./pages/AiResume/AiResumeList";
import { MarketplaceJobs } from "./components/MarketplaceJobs";
import ProfessionalResumeList from "./pages/ProfessionalResume/ProfessionalResume";
import CustomSub from "./pages/CustomSubscription/CustomSub";
import CustomPlans from "./pages/UserManager/CustomPlans/CustomPlans";
import DefaultPlans from "./pages/UserManager/CustomPlans/DefaultPlans";
import UserRequest from "./pages/CustomSubscription/Request/UserRequest";
import UnverifiedUser from "./pages/PendingApproval/UnverifiedUser/UnverifiedUser";
import RequestDeleteList from "./pages/UserManager/RequestDelete/RequestDeleteList";
import InvoiceList from "./pages/UserManager/InvoiceList/InvoiceList";
import Flexpert from "./pages/Flexpert/flexpert";
import Overall from "./pages/PaymentsAndnvoices/Overall/Overall";
import CreateInvoice from "./pages/PaymentsAndnvoices/CreateInvoice/CreateInvoice";
import Proforma from "./pages/PaymentsAndnvoices/ProformaInvoice/Proforma";
import ExternalPaymemnt from "./pages/PaymentsAndnvoices/ExternalPayments/ExternalPayment";
import PlatformPayments from "./pages/PaymentsAndnvoices/PlatformPayments/PlatformPayment";
import JobMorganic from "./pages/JobManager/OrganicJobs/JobMorganic";
import JobMOrganicList from "./pages/JobManager/OrganicJobs/JobMOriganicList";
import JobMvendoronly from "./pages/JobManager/VendoronlyJobs/JobMvendoronly";
import JobMVendorExclusiveList from "./pages/JobManager/VendoronlyJobs/JobMVendorexclusiveList";
import ShortenUrl from "./pages/ShortenUrl/ShortenUrl";
import ShortenUrlList from "./pages/ShortenUrl/ShortenUrlList";
import ShortenUrlUpdate from "./pages/ShortenUrl/ShortenUrlUpdate";
import SalesUsersList from "./pages/Users/SalesUsers/SalesUsersList";
import CmsUsersList from "./pages/Users/CmsUsers/CmsUsersList";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2EBAA3", 
    },
  },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="Login" element={<Login />} />
          <Route
            path="/"
            element={isLoggedIn() === true ? <Holder /> : <Login />}
          >
            <Route index element={<Dashboard />}/>
            <Route path="/Dashboard" element={<Dashboard />}/>
            <Route path="/PendingApproval" element={<PendingApproval />}>
              <Route path="ClientApproval" element={<PendingClient/>}>
                <Route path="" element={<PendingClientList />}/>
              </Route>
              <Route path="VendorApproval" element={<PendingVendor/>}>
                <Route path="" element={<PendingVendorList />}/>
              </Route>
              <Route path="JobApproval" element={<PendingJob />}>
                <Route path="" element={<PendingJobList />}/>
              </Route>
              <Route path="ProjectApproval" element={<PendingProject />}>
                <Route path="" element={<PendingProjectList />}/>
              </Route>
               <Route path="UnverifiedUser" >
                <Route path="" element={<UnverifiedUser />}></Route>
              </Route>
            </Route>

            <Route path="/EmailTemplates" element={<EmailTemp />}>
              <Route path="Templates" element={<EmailTemplates />}>
                <Route path="" element={<EmailTempList />}/>
                <Route path="Create" element={<EmailTempUpdate />}/>
                <Route path="DesignList" element={<EmailTemplateDesignList />}/>
                <Route path="Design" element={<EmailTemplateDesign />}/>
              </Route>
            </Route>

            <Route path="/FAQ" element={<FAQ />}>
              <Route path="" element={<FAQList />}/>
              <Route path="Create" element={<FAQUpdate />}/>
              <Route path="Sort" element={<FAQSort />}/>
            </Route>

            <Route path="/BusinessType" element={<BusinessType />}>
              <Route path="" element={<BusinessTypeList />}/>
              <Route path="Create" element={<BusinessTypeUpdate />}/>
            </Route>

            <Route path="/JobCategory" element={<JobCategory />}>
              <Route path="" element={<JobCategoryTypeList />}/>
              <Route path="Create" element={<JobCategoryUpdate />}/>
            </Route>

            <Route path="/GenerateInvestorUrl" element={<GenerateInvestorUrlWrapper />}>
              <Route path="" element={<GenerateInvestorUrl />}/>
            </Route>

            <Route path="/ShortenUrl" element={<ShortenUrl />}>
              <Route path="" element={<ShortenUrlList />}/>
              <Route path="Create" element={<ShortenUrlUpdate />}/>
            </Route>

            <Route path="/sales-users" element={<SalesUsersList />}/>
            <Route path="/cms-users" element={<CmsUsersList />}/>

            <Route path="/UserManager" element={<UserManager />}>
              <Route path="Client" element={<ClientUser />}>
                <Route path="" element={<ClientUserList />}/>
                <Route path="client-info/:userid" element={<UserInfoDashboard />}/>
                <Route path="vendor-list/:vendorid" element={<ClientVendorConnection />}/>
                <Route path="client-info/:userid/marketplaceJobs" element={<MarketplaceJobs />}/>
              </Route>

              <Route path="Consultant" element={<ConsultantUser />}>
                <Route path="" element={<ConsultantUserList />}/>
              </Route>

              <Route path="Vendor" element={<VendorUser />}>
                <Route path="" element={<VendorUserList />}/>
                <Route path="vendor-info/:userid" element={<UserInfoDashboard />}/>
                <Route path="cvr-list/:vendorid" element={<VendorClientResourcesConnectionList />}/>
                <Route path="vendor-info/:userid/marketplaceJobs" element={<MarketplaceJobs />}/>
              </Route>
              <Route path="DeletedUsers" element={<DeletedUsersList />}/>
              <Route path="RequestDelete" element={<RequestDeleteList />}/>
              <Route path="CustomPlans" element={<CustomPlans />}/>
              <Route path="DefaultPlans" element={<DefaultPlans />}/>
              <Route path="InvoiceList" element={<InvoiceList/>}/>
            </Route>

            <Route path="/Flexperts" element={<FlexpertsLayout />}>
              <Route path="" element={<Navigate to="list" replace />}/>
              <Route path="list" element={<FlexpertUserList />}/>
              <Route path="requests" element={<FlexpertRequestsList />}/>
            </Route>

            <Route path="/JobManager" element={<JobManager />}>
              {/* Manage Broadcast Jobs / Manage Posted Jobs removed from CMS
              <Route path="Job" element={<JobMJobSub />}>
                <Route path="" element={<JobMJobList />}/>
              </Route>
              <Route path="JobSub" element={<JobMJobSub />}>
                <Route path="" element={<JobMSubList />}/>
              </Route>
              */}
              <Route path="OrganicJobs" element={<JobMorganic />}>
                <Route path="" element={<JobMOrganicList />}/>
              </Route>
              <Route path="VendoronlyJobs" element={<JobMvendoronly />}>
                <Route path="" element={<JobMVendorExclusiveList />}/>
              </Route>
            </Route>

            <Route path="/PaymentsAndInvoices" element={<JobManager />}>
              <Route path="Overall" element={<Overall />}>
                <Route path="" element={<Overall />}/>
              </Route>
              <Route path="CreateInvoice" element={<CreateInvoice />}>
                <Route path="" element={<CreateInvoice />}/>
              </Route>
              <Route path="Proforma" element={<Proforma />}>
                <Route path="" element={<Proforma />}/>
              </Route>
              <Route path="ExternalPayments" element={<ExternalPaymemnt />}>
                <Route path="" element={<ExternalPaymemnt />}/>
              </Route>
              <Route path="PlatformPayments" element={<PlatformPayments />}>
                <Route path="" element={<PlatformPayments />}/>
              </Route>
            </Route>
            <Route path="/ai-mockinterview" element={<MockInterviewList/>}/>
            <Route path="/ai-resume" element={<AiResumeList/>}/>
            <Route path="/professional-resume" element={<ProfessionalResumeList/>}/>
            <Route path="/custom-subscription" element={<CustomSub/>}/>
            <Route path="/custom-subscription/request" element={<UserRequest/>}/>
            <Route path="/resource-enquiry" element={<Flexpert />}/>

          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
  }

  export default App;
